export default __webpack_public_path__ + "static/media/instagram--gold.2cd9f14e.svg";